import { render, staticRenderFns } from "./CustomerReview.vue?vue&type=template&id=76c35a18&scoped=true&"
import script from "./CustomerReview.vue?vue&type=script&lang=ts&"
export * from "./CustomerReview.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerReview.vue?vue&type=style&index=0&id=76c35a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c35a18",
  null
  
)

export default component.exports